import { render, staticRenderFns } from "./policySupport.vue?vue&type=template&id=47349ac2&scoped=true&"
import script from "./policySupport.vue?vue&type=script&lang=js&"
export * from "./policySupport.vue?vue&type=script&lang=js&"
import style0 from "./policySupport.vue?vue&type=style&index=0&id=47349ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47349ac2",
  null
  
)

export default component.exports